<template>
  <div>
    <CardWithImageAndButton 
    title="Сервис поиска датасетов"
    text="
    Интеллектуальная платформа для поиска, анализа и конструирования открытых наборов данных, готовых к безопасному использованию в системах ИИ.
    <br /><br />
    В основе решения — собственный реестр проверенных источников данных, а также интеллектуальный диспетчер обкачки, который совместно с краулером сканирует интернет-пространство.
    <br /><br />
    Встроенный анализатор данных даёт первичную оценку содержимого и пригодности датасета, а система обезличивания обеспечивает соответствие требованиям по защите персональной информации.
    "
    :imagePath="require('../../assets/imgs/search-for-datasets.png')"
    imagePosition="right"
    :buttonIsVisible="false"
    />
    <List :items="listItems" title="Что мы предлагаем" theme="dark" />
  </div>
</template>

<script>
import { CardWithImageAndButton, List } from 'sputnik-ui/src/index';
export default {
  name: 'SearchForDatasetsPage',
  components: {
    CardWithImageAndButton,
    List
  },
  data() {
    return {
      listItems: [
        {text: "Реестр источников данных"},
        {text: "Диспетчер обкачки и краулер"},
        {text: "Индексирование"},
        {text: "Пользовательский интерфейс простого поиска"},
        {text: "Безопасное хранение"},
        {text: "Анализатор данных"},
        {text: "Конструктор датасетов"},
        {text: "Обезличивание"},
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
  .wrapper {
    padding-top: 50px;
    padding-bottom: 50px;
  }
</style>